import { ErrorCode } from "./errorcode";
import { ISong } from "./song.interface";
import { IPlaylist } from "./playlist.interface";
import { IPlaylistSongs } from './playlistsongs.interface';
import { IScheduler } from './scheduler.interface';

export class State {
    constructor(
        public allTimeSong?: number,
        public cache_time?: number,
        public currentPlaylistName?: string,
        public currentSong?: ISong,
        public currentTimeSong?: number,
        public mainPlaylistSongs?: ISong[],
        public playlists?: IPlaylist[],
        public shuffle?: number,
        public volume?: number,
        public searchResultsList?: ISong[],
        public playlistSongs?: IPlaylistSongs[],

        public errorCode?: ErrorCode,
        public error?: string,

        /** Set when response includes scheduler (e.g. Get Scheduler command id 100). */
        public scheduler?: IScheduler,
    ) {
    }

    public init(): State {
        this.allTimeSong = 0;
        this.cache_time = 0;
        this.currentPlaylistName = "";
        this.currentSong = { id: 0, name: "" };
        this.currentTimeSong = 0;
        this.mainPlaylistSongs = [];
        this.playlists = [];
        this.shuffle = 0;
        this.volume = 0;
        this.searchResultsList = [];
        this.playlistSongs = [];

        return this;
    }
}

/**
 * State packets normally arrive as an array (`[{...},{...}]`), but some server/player branches
 * answer with a bare object (e.g. `{"id":1,"scheduler":{...}}`). Consumers iterate the payload,
 * so a bare object used to throw and lose the whole packet - wrap it instead.
 */
export function toStateArray(payload: unknown): State[] {
    if (Array.isArray(payload)) {
        return payload as State[];
    }
    if (payload && typeof payload === 'object') {
        return [payload as State];
    }
    return [];
}